var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlistStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63542 0.5H7.40104C7.52865 1.33984 7.875 2.25781 8.45833 3.25391C9.625 5.22656 11.9766 7.16016 14 7.60938V8.42969C12.9974 8.66406 12.013 9.15234 11.0651 9.875C9.13281 11.3398 7.71094 13.5273 7.40104 15.5H6.63542C6.45312 14.4648 6.03385 13.4688 5.3776 12.4531C4.08333 10.4414 2.0599 8.95703 0 8.42969L0 7.60938C1.03906 7.375 2.09635 6.82812 3.13542 5.98828C5.25 4.28906 6.36198 2.17969 6.63542 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistStar);
export default __webpack_public_path__ + "static/media/wishlist-star.fd5df2a6090b981a1b05dfc9eba34b55.svg";
export { ForwardRef as ReactComponent };